var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo44({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.533,
    height: 20.124,
    viewBox: "0 0 20.533 20.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45253",
    "data-name": "Group 45253",
    transform: "translate(1219.7 -6143.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45252",
    "data-name": "Group 45252",
    transform: "translate(-1219.7 6143.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45247",
    "data-name": "Group 45247",
    transform: "translate(13.972 8.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89531",
    "data-name": "Path 89531",
    d: "M27.373,25.4a.257.257,0,0,1-.209-.07l-5.511-2.374a.525.525,0,0,1-.35-.489V16.743a.525.525,0,0,1,.35-.489l5.511-2.374a.435.435,0,0,1,.489.07.5.5,0,0,1,.209.419V24.844a.422.422,0,0,1-.209.419C27.513,25.333,27.443,25.4,27.373,25.4Zm-5.028-3.282,4.464,1.961V15.207l-4.47,1.955Z",
    transform: "translate(-21.304 -13.835)",
    fill: "#0c66e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45248",
    "data-name": "Group 45248",
    transform: "translate(0.07 9.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89532",
    "data-name": "Path 89532",
    d: "M14.808,25.035H2.936A1.55,1.55,0,0,1,1.4,23.5V16.236A1.55,1.55,0,0,1,2.936,14.7H14.808a1.55,1.55,0,0,1,1.53,1.536V23.5a1.55,1.55,0,0,1-1.53,1.536ZM2.936,15.753a.477.477,0,0,0-.489.489V23.5a.477.477,0,0,0,.489.489H14.808A.477.477,0,0,0,15.3,23.5V16.236a.477.477,0,0,0-.489-.489Z",
    transform: "translate(-1.4 -14.7)",
    fill: "#0c66e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45249",
    "data-name": "Group 45249",
    transform: "translate(8.449 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89533",
    "data-name": "Path 89533",
    d: "M17.316,9.425a3.9,3.9,0,1,1,2.772-1.143,3.916,3.916,0,0,1-2.772,1.143Zm0-6.774a2.832,2.832,0,0,0-2.869,2.869,2.876,2.876,0,0,0,2.869,2.858,2.832,2.832,0,0,0,2.859-2.858A2.876,2.876,0,0,0,17.316,2.65Z",
    transform: "translate(-13.4 -1.593)",
    fill: "#0c66e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45250",
    "data-name": "Group 45250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89534",
    "data-name": "Path 89534",
    d: "M5.216,9.425A3.9,3.9,0,1,1,7.988,8.281,3.916,3.916,0,0,1,5.216,9.425Zm0-6.774a2.864,2.864,0,1,0,0,5.727A2.832,2.832,0,0,0,8.074,5.519,2.922,2.922,0,0,0,5.216,2.65Z",
    transform: "translate(-1.3 -1.593)",
    fill: "#0c66e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45251",
    "data-name": "Group 45251",
    transform: "translate(3.631 15.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64019",
    "data-name": "Rectangle 64019",
    width: 4.889,
    height: 1.047,
    fill: "#0c66e4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo44);
export default __webpack_public_path__ + "static/media/video44.2634a70228fceedfb8b82b3ca9bef785.svg";
export { ForwardRef as ReactComponent };